import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { DatasearchService } from '../../_services/datasearch.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink, CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})

export class FooterComponent {
  footerdata: any = {};
  baseurl = 'https://www.chemrobotics.com/agropat/uploads/thumbnail/'
  constructor(private datasearch_service: DatasearchService, private router: Router) { }
  ngOnInit() {
    this.getfooterData();
  }
  getfooterData() {
    this.datasearch_service.getFooter().subscribe((res) => {
      console.log('Footer API Response:', res);
      if (res.success && res.data) {
        if (Array.isArray(res.data)) {
          if (res.data.length > 0) {
            this.footerdata = res.data[0];
          } else {
            this.footerdata = {};
          }
        } else {
          this.footerdata = res.data;
        }
      }
    }, (error) => {
      console.error('Error fetching footer data', error);
    });
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
